import React, { Component } from 'react';
import { FormGroup, Row, Col, Label, Input, FormText } from 'reactstrap';

export default class Employment extends Component {
    constructor(props) {
        super(props)

        this.state = {

        };
    }

    render() {
        return (
            <div>
                <Row>
                    <Col sm='12'>
                        <FormGroup>
                            <Label>Organization Name</Label>
                            <Input name='organizationName' required maxLength="50" value={this.props.item.organizationName || ''} onChange={this.props.onChange} />
                        </FormGroup>
                    </Col>
                </Row>
                <Row>
                    <Col sm='12'>
                        <FormGroup>
                            <Label>Title</Label>
                            <Input name='title' required maxLength="50" value={this.props.item.title || ''} onChange={this.props.onChange} />
                        </FormGroup>
                    </Col>
                </Row>
                <Row className='mt-2'>
                    <Col sm='6'>
                        <FormGroup>
                            <Label>Start Date</Label>
                            <Input type="date" required name='startDate' value={this.props.item.startDate || ''} onChange={this.props.onChange} max="9999-12-31"/>
                            <FormText color="muted">Format: mm/dd/yyyy</FormText>
                        </FormGroup>
                    </Col>
                    <Col sm='6'>
                        <FormGroup>
                            <Label>End Date</Label>
                            <Input type="date" name='endDate' value={this.props.item.endDate || ''} onChange={this.props.onChange} max="9999-12-31"/>
                            <FormText color="muted">Format: mm/dd/yyyy</FormText>
                        </FormGroup>
                    </Col>
                </Row>
                <Row>
                    <Col sm='6'>
                        <FormGroup>
                            <Label>Mailing Address 1</Label>
                            <Input name='mailingAddress1' required maxLength="50" value={this.props.item.mailingAddress1 || ''} onChange={this.props.onChange} />
                        </FormGroup>
                    </Col>
                    <Col sm='6'>
                        <FormGroup>
                            <Label>Mailing Address 2</Label>
                            <Input name='mailingAddress2' maxLength="50" value={this.props.item.mailingAddress2 || ''} onChange={this.props.onChange} />
                        </FormGroup>
                    </Col>
                </Row>
                <Row>
                    <Col sm='6'>
                        <FormGroup>
                            <Label>Mailing State</Label>
                            <Input name='mailingState' required maxLength="2" value={this.props.item.mailingState || ''} onChange={this.props.onChange} />
                        </FormGroup>
                    </Col>
                    <Col sm='6'>
                        <FormGroup>
                            <Label>Mailing Zip</Label>
                            <Input name='mailingZip' required maxLength="10" value={this.props.item.mailingZip || ''} onChange={this.props.onChange} />
                        </FormGroup>
                    </Col>
                </Row>
                <Row>
                    <Col sm='4'>
                        <FormGroup>
                            <Label>Office Phone</Label>
                            <Input name='officePhone' required pattern='^[2-9]\d{2}\d{3}\d{4}$|^[2-9]\d{2}-\d{3}-\d{4}$|^\d{12}$' maxLength='25' placeholder="###-###-####" value={this.props.item.officePhone || ''} onChange={this.props.onChange} />
                        </FormGroup>
                    </Col>
                    <Col sm='4'>
                        <FormGroup>
                            <Label>Cell Phone</Label>
                            <Input name='cellPhone' pattern='^[2-9]\d{2}\d{3}\d{4}$|^[2-9]\d{2}-\d{3}-\d{4}$|^\d{12}$' maxLength='25' placeholder="###-###-####" value={this.props.item.cellPhone || ''} onChange={this.props.onChange} />
                        </FormGroup>
                    </Col>
                    <Col sm='4'>
                        <FormGroup>
                            <Label>Fax Number</Label>
                            <Input name='faxNumber' pattern='^[2-9]\d{2}\d{3}\d{4}$|^[2-9]\d{2}-\d{3}-\d{4}$|^\d{12}$' maxLength='25' placeholder="###-###-####" value={this.props.item.faxNumber || ''} onChange={this.props.onChange} />
                        </FormGroup>
                    </Col>
                </Row>
            </div>
        )
    }
}